"use strict";

exports.__esModule = true;
exports.SelectionContext = void 0;
var _Utils = require("../../../Utils");
var _SelectionController = require("./SelectionController");
/**
 * Provides (optionally context-sensitive) help across the application.
 *
 * @component
 */
var SelectionContext = exports.SelectionContext = (0, _Utils.createEnhancedContext)({
  propName: "selection",
  defaultController: _SelectionController.SelectionController
});